<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>radio_button_checked</v-icon>
                     Radio:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />
                    <v-btn @click="openModal(true)" class="mx-2 py-0" color="primary">
                        <v-icon>add_circle</v-icon>
                    </v-btn>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="channels"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.private="{ item }">
                        <v-chip :color="getColor(item.private)" dark >{{ getData(item.private) }}</v-chip>
                    </template>
                    <template v-slot:item.role="{ item }">
                        {{item.role.length > 0 ? item.role : 'Todos'}}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>

                </v-data-table>
            </v-card>
            <v-dialog
                    v-model="dialog"
                    width="600"

            >
                <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
                    <v-card>
                        <v-card-title class="headline text-center">{{edit ? 'Editar': 'Crear'}} Canal de radio</v-card-title>
                        <v-form
                                @submit.prevent="handleSubmit(formSubmit)"
                                ref="form"
                                lazy-validation
                                class="container"
                        >
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" name="name" v-slot="{ errors, valid }">
                                        <v-text-field
                                                name="name"
                                                v-model="radio.name"
                                                label="Nombre:"
                                                placeholder="Ingresa el nombre"
                                                :error-messages="errors"
                                                :success="valid"
                                        />
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" name="private" v-slot="{ errors, valid }">
                                        <v-switch
                                                @change="changePrivate"
                                                name="private"
                                                v-model="radio.private"
                                                label="¿Privado?"
                                                :error-messages="errors"
                                                :success="valid"

                                        />
                                    </ValidationProvider>

                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" >
                                    <ValidationProvider :rules="rulesRoles" name="role" v-slot="{ errors, valid }">
                                        <v-select
                                                v-model="radio.role"
                                                v-if="rulesRoles.length > 0"
                                                name="rol"
                                                label="Rol"
                                                :items="roles"
                                        />
                                        <v-select
                                                v-model="radio.role"
                                               v-else
                                               disabled
                                                name="rol"
                                                label="Rol"
                                                :items="roles"
                                        />
                                    </ValidationProvider>
                                </v-col>

                            </v-row>


                            <v-card-actions>


                                <v-spacer/>
                                <v-btn type="submit">{{edit ? 'editar' : 'Guardar'}}</v-btn>


                            </v-card-actions>
                        </v-form>

                    </v-card>
                </ValidationObserver>
            </v-dialog>
            <v-snackbar
                    color="success"
                    v-model="snackbar"
            >
                {{ text }}
                <v-btn
                        color="darken"
                        text
                        @click="snackbar = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
        </v-container>
    </v-content>
</template>

<script>

    import {ROLE} from '../plugins/config'

    import {
        ValidationObserver,
    } from "vee-validate";

    import {mapState, mapActions} from "vuex";

    export default {
        name: "Radio",
        data(){
            return{
                idItem:null,
                rulesRoles:'',
                valid:true,
                search:'',
                dialog:'',
                edit:false,
                snackbar:false,
                text:'',
                roles:ROLE,
                radio:{
                    name:'',
                    private:false,
                    role:''
                },
                headers: [
                    {
                        text: 'Nombre',
                        align: 'left',
                        sortable: true,
                        value: 'name',
                    },
                    { text: 'Privado?', value: 'private' },
                    { text: 'Rol', value: 'role' },
                    { text: 'Opciones', value: 'actions' },


                ],
            }
        },
        components:{
            ValidationObserver
        },
        methods:{
            ...mapActions([
                'createChannel', 'editChannel', 'deleteChannel'
            ]),
            getColor(value){
                if (value){
                    return 'success'
                }else {
                    return 'red'
                }
            },
            getData(value){
                if (value){
                    return 'Si'
                }else {
                    return 'No'
                }
            },
            formSubmit(){
                if (this.edit){
                    this.editRadio()
                }else {
                    this.saveRadio()
                }
            },
            deleteItem(item){
                this.deleteChannel(item.id)
            },
            openModal(value){
                this.radio = {
                    name:'',
                    private:false,
                    role:''
                }
                this.dialog = value;
                this.edit = false

            },
            editItem(item){
                this.edit = true;
                this.radio.role = item.role;
                this.radio.name = item.name;
                this.radio.private = item.private;
                this.idItem = item.id;

                this.dialog = true

            },
            editRadio(){
                this.editChannel({id:this.idItem, data:this.radio});
                this.dialog = false;
            },
            saveRadio(){
                this.createChannel(this.radio);
                this.dialog = false;
                this.radio = {
                    name:'',
                    private:false,
                    role:''
                }
                this.rulesRoles = ''

                this.text = 'Se ha creado satisfactoriamente';
                this.snackbar = true;
            },
            changePrivate(){
                if (this.radio.private === true){
                    this.rulesRoles = 'required'
                }else {
                    this.rulesRoles = '';
                    this.radio.role = '';
                }
            }
        },
        computed:{
            ...mapState({
                channels:state => state.radio.channels
            })
        },
    }
</script>

<style scoped>

</style>